import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  constructor(private http: HttpClient) { }

  public getJSON(): Observable<any> {
    return this.http.get("../../../assets/i18n/hr-HR.json")
}
}
